module.exports = __webpack_public_path__ + "3aa08278ac0be286a2316e254aaeaa8c.MP3";